export default "__VITE_ASSET__BBPNYoWc__"